import { getLayer } from '../layerService.js';

export default class PageCreateCommand {
    constructor({ pageUuid, pageHaspId, pageObj }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = 'Add page P' + pageHaspId;
        this.category = 'structure';
        this.pageUuid = pageUuid;
        this.pageHaspId = pageHaspId;
        this.pageObj = pageObj ?? 'page';
    }

    execute() {
        const layer = getLayer();
        if (!layer) return;
        layer.addPage({ obj: this.pageObj, page: this.pageHaspId, _uuid: this.pageUuid });
        layer.batchDraw();
    }

    undo() {
        const layer = getLayer();
        if (!layer) return;
        const page = layer.findOne('#' + this.pageUuid) ?? layer.findPage(this.pageHaspId);
        if (!page) return;
        // Switch to a different page before destroying
        const other = layer.children.find(c => c !== page && (c.obj === 'page' || c.obj === 'template_page') && c.haspid !== 0);
        if (other) layer.switchToPage(other);
        page.destroy();
        layer.batchDraw();
    }

    toJSON() {
        return {
            type: 'PageCreate',
            id: this.id,
            timestamp: this.timestamp,
            payload: { pageUuid: this.pageUuid, pageHaspId: this.pageHaspId, pageObj: this.pageObj },
        };
    }
}
